import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default ({
  title,
  ...extra
}) => /*#__PURE__*/_jsxs("svg", {
  height: "50",
  width: "50",
  viewBox: "0 0 50 50",
  fill: "#1aa",
  ...extra,
  children: [title, /*#__PURE__*/_jsx("path", {
    d: "M8.696 28.129C11.58 29.54 18.729 30.435 25 30.435c6.27 0 13.419-.895 16.304-2.306v-8.564S32.525 21.212 25 21.212c-7.525 0-16.304-1.647-16.304-1.647v8.564zM25 0C6 0 0 2.45 0 2.45v13.1h8.174V7.826c3.333.667 8.026 2 16.826 2s14.16-1.333 16.826-2v7.724H50V2.45S44 0 25 0zM25 50c19 0 25-4.624 25-4.624V34.45h-8.174V40S39.13 43.478 25 43.478 8.174 40 8.174 40v-5.55H0v10.926S6 50 25 50z"
  })]
});